// alertUtility.js
export function ArchiveAlert(message) {
  const alertBox = document.createElement("div");

  // Set the HTML content with responsive SVG class
  alertBox.innerHTML = `
      <div style="display: flex; align-items: center; gap: 12px;">
        <svg class="archive-alert-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="4" fill="#FFEAEB"/>
            <path d="M30.1111 10H10.1111C9.49746 10 9 10.4975 9 11.1111V14.4444C9 15.0581 9.49746 15.5556 10.1111 15.5556H30.1111C30.7248 15.5556 31.2222 15.0581 31.2222 14.4444V11.1111C31.2222 10.4975 30.7248 10 30.1111 10Z" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.2222 15.5555V27.7778C11.2222 28.3671 11.4563 28.9324 11.873 29.3491C12.2898 29.7659 12.855 30 13.4444 30H26.7777C27.3671 30 27.9323 29.7659 28.3491 29.3491C28.7658 28.9324 28.9999 28.3671 28.9999 27.7778V15.5555" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.1113 18.8889V24.4445" stroke="#FF0000" stroke-width="1.5"/>
            <path d="M23.4445 21.6666L20.1112 25L16.7778 21.6666" stroke="#FF0000" stroke-width="1.5"/>
        </svg>
        <span class="alert-message ftw-4 common-text">${message}</span>
      </div>
    `;

  // Style the alert container
  alertBox.style.position = "fixed";
  alertBox.style.left = "50%";
  alertBox.style.top = "100px";
  alertBox.style.transform = "translateX(-50%)";
  alertBox.style.backgroundColor = "#FFF";
  alertBox.style.borderRadius = "13px";
  alertBox.style.padding = "12px 16px";
  alertBox.style.boxSizing = "border-box";
  alertBox.style.zIndex = "1000";
  alertBox.style.animation = "slideDown 0.3s ease-out forwards";
  alertBox.style.boxShadow = "0 13px 27px 0 rgba(0, 0, 0, 0.10)";

  // Add animation keyframes and responsive styles
  const styleSheet = document.createElement("style");
  styleSheet.textContent = `
      .alert-message {
        font-size: 0.875rem;
      }
      .archive-alert-icon {
        width: 40px;
        height: 40px;
        flex-shrink: 0;
      }
      
      /* Responsive breakpoints for archive alert icon */
      @media (max-width: 1599px) {
        .archive-alert-icon { width: 36px; height: 36px; }
      }
      
      @media (max-width: 1399px) {
        .archive-alert-icon { width: 32px; height: 32px; }
      }
      
      @media (max-width: 1199px) {
        .archive-alert-icon { width: 28px; height: 28px; }
      }
      
      @media (max-width: 991px) {
        .archive-alert-icon { width: 24px; height: 24px; }
      }
      
      @media (max-width: 767px) {
        .archive-alert-icon { width: 20px; height: 20px; }
      }
      
      @media (max-width: 575px) {
        .archive-alert-icon { width: 18px; height: 18px; }
      }
      
      @keyframes slideDown {
        from {
          opacity: 0;
          transform: translate(-50%, -20px);
        }
        to {
          opacity: 1;
          transform: translate(-50%, 0);
        }
      }
      
      @keyframes fadeOut {
        from {
          opacity: 1;
          transform: translate(-50%, 0);
        }
        to {
          opacity: 0;
          transform: translate(-50%, -20px);
        }
      }
    `;
  document.head.appendChild(styleSheet);

  // Add the alert to the page
  document.body.appendChild(alertBox);

  // Add the alert-box class to the alertBox element
  alertBox.classList.add("alert-box");

  // Remove the alert after 3 seconds
  setTimeout(() => {
    alertBox.style.animation = "fadeOut 0.3s ease-out forwards";
    setTimeout(() => {
      if (document.body.contains(alertBox)) {
        document.body.removeChild(alertBox);
      }
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    }, 300);
  }, 3000);
}
